import React from 'react'
import { Link } from 'react-router-dom'; 
import PropTypes from "prop-types";  
import '../../assets/css/receipt.css'; 
//const deviceWidth = window.innerWidth > 650 ? true : false

export default function ReceiptLayout({ children }) { 
    return (
        <>  
           {children}
        </>
    )
}

ReceiptLayout.propTypes = {
    children: PropTypes.element.isRequired
};

